import React from "react";
import CandidatesRow from "../molecule/CandidatesRow";

const CandidateTable = ({
  candidates,
  selectedIds,
  toggleSelect,
  onViewCandidate,
  onViewDocs,
}) => {
  return (
    <div className="overflow-x-auto bg-white rounded shadow-md">
      <table className="min-w-full table-auto">
        <thead className="text-left bg-gray-100">
          <tr>
            <th className="p-4">
              <input type="checkbox" disabled />
            </th>
            {[
              "Candidate ID",
              "Full Names",
              "Email",
              "Gender",
              "Phone",
              "Previous Job Position",
              "Status",
              "More Documents",
            ].map((h, i) => (
              <th key={i} className="p-4 text-sm font-semibold text-gray-700">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(candidates) && candidates.length > 0 ? (
            candidates.map((row, i) => {
              const rid =
                row?.id ?? row?.candidateId ?? row?.applicationId ?? String(i);
              const isSel = selectedIds.includes(String(rid));

              return (
                <CandidatesRow
                  key={rid}
                  candidates={row}
                  isSelected={isSel}
                  onSelect={toggleSelect}
                  onViewCandidate={onViewCandidate}
                  onViewDocs={onViewDocs}
                />
              );
            })
          ) : (
            <tr>
              <td colSpan={9} className="p-4 text-center text-gray-500">
                No Candidates available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CandidateTable;
